import { createSelector } from "@ngrx/store";
import { NEWS_PER_PAGE } from "src/app/constants";
import { sortByVisibleFrom } from "src/app/utils/sort-by-date";
import { RootState } from "..";
import { ManyNews } from "./state";

export const selectLoading = (state: RootState): boolean => state.news.loading;

export const selectFeature = (state: RootState): ManyNews => state.news.data;

export const selectCurrentPage = (state: RootState): number => state.news.currentPage;

export const selectTotalPages = (state: RootState): number => state.news.pageCount;

export const selectAll = createSelector(selectFeature, news => Object.values(news).sort(sortByVisibleFrom));

export const selectLastOnes = createSelector(selectAll, news => news.slice(0, NEWS_PER_PAGE));
